<script lang="ts">
  import "../app.css";
  import { afterNavigate, beforeNavigate } from "$app/navigation";
  import { updated } from "$app/state";
  import { crossesDemo, headFor } from "#lib/demo/live.ts";
  import { QueryClientProvider } from "@tanstack/svelte-query";
  import { m } from "#messages";
  import { rememberSignIn } from "#lib/entrance/login.ts";
  import { forgetFresh } from "#lib/fresh.ts";
  import { claimFreshLoad, stopPreloadingStaleRoutes } from "#lib/stale-build.ts";
  import NavigationProgress from "#lib/shell/NavigationProgress.svelte";
  import Toasts from "#lib/ui/Toasts.svelte";
  import Upgrades from "#lib/ui/Upgrades.svelte";
  import { queryClient } from "#lib/query.ts";
  import type { LayoutProps } from "./$types.ts";

  let { data, children }: LayoutProps = $props();

  beforeNavigate((navigation) => {
    const to = navigation.to?.url;
    if (
      to !== undefined &&
      navigation.type !== "leave" &&
      (crossesDemo(navigation.from?.url.pathname, to.pathname) ||
        (updated.current && claimFreshLoad()))
    ) {
      navigation.cancel();
      (window.top ?? window).location.assign(to.href);
      return;
    }
    headFor(to?.pathname);
  });
  afterNavigate((navigation) => {
    forgetFresh();
    headFor(undefined);
    if (window.self !== window.parent)
      window.parent.postMessage(
        {
          demoAt: location.href,
          title: document.title,
          delta: navigation.type === "popstate" ? navigation.delta : 0,
        },
        location.origin,
      );
  });

  $effect(() => {
    if (window.self === window.parent) return;
    const push = history.pushState;
    history.pushState = (...args) => {
      push.apply(history, args);
      window.parent.postMessage({ demoPushed: true }, location.origin);
    };
    return () => {
      history.pushState = push;
    };
  });

  $effect(() => {
    document.documentElement.lang = data.locale;
  });

  $effect(stopPreloadingStaleRoutes);

  $effect(() => {
    document.getElementById("boot")?.remove();
    document.documentElement.classList.remove("resuming");
  });
</script>

<svelte:document onclickcapture={rememberSignIn} />

<svelte:head>
  <title>{m.app_name()}</title>
</svelte:head>

<QueryClientProvider client={queryClient()}>
  {@render children()}

  <NavigationProgress />
  <Toasts />
  <Upgrades />
</QueryClientProvider>
